import React, { createContext, useState, ReactNode, useContext } from "react";

interface PreviousPathContextType {
    previousPath: string | null;
    setPreviousPath: (path: string | null) => void;
}
const PreviousPathContext = createContext<PreviousPathContextType | undefined>(undefined);
export const PreviousPathProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [previousPath, setPreviousPath] = useState<string | null>(null);
    return (
        <PreviousPathContext.Provider value={{ previousPath, setPreviousPath }}>
            {children}
        </PreviousPathContext.Provider>
    );
};
export const usePreviousPath = (): PreviousPathContextType => {
    const context = useContext(PreviousPathContext);
    if (!context) {
        throw new Error('use previous path undefined');
    }
    return context;
}